import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostBlockedSlotBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Creates a blocked slot for a vet and invalidates the blocked-slots query cache. */
export function useCreateBlockedSlot() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostBlockedSlotBody) => {
      const response = await api.post('/blocked-slots', { body })
      if (!response.success) {
        throw new Error(response.error.message)
      }
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blocked-slots'] })
    },
  })
}
